import { marked } from "marked";
import DOMPurify from 'isomorphic-dompurify';

interface ParseMarkdownOptions {
  autoRenderEmail?: boolean;
}

export default function parseMarkdown(markdown: string, options: ParseMarkdownOptions = {}) {

  const parsedHtml = marked.parse(DOMPurify.sanitize(markdown));

  if (typeof parsedHtml !== 'string') {

    return '';

  }

  if (options.autoRenderEmail !== false) {

    return parsedHtml;

  }

  // Keep plain-text emails as text when auto email rendering is disabled.
  return parsedHtml.replace(
    /<a href="mailto:([^"]+)">([^<]+)<\/a>/gi,
    (fullMatch: string, ...matches: string[]) => {

      const email = matches[0] || '';
      const text = matches[1] || '';

      return text.trim().toLowerCase() === email.toLowerCase() ? text : fullMatch;

    },
  );

}
